import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/boardList.module.scss';
//hooks
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import useComnStore from 'src/webapp/stores/comn.store';
//CompWrapper
import Element from 'src/webapp/views/wrapper/Element';
import Button from 'src/webapp/views/component/Button';//버튼엘리먼트

export default function CouponList (props, ref) {
    const navigator = useNavigate();
    //hook
    const { axiosPostHandler } = useAxiosHook();
    //store
    const { setMessage } = useComnStore();
    const { list, setList } = props;
    /* ==================== 쿠폰삭제 ==================== */
    const isLock = useRef(false);
    const couponDeactivationAPI = async(data) => {
        if(!window.confirm("데이터를 삭제한 후에는 다시 복구할 수 없습니다.\n삭제하시겠습니까?")) { return; }
        try {
            if (isLock.current) { return; }
            isLock.current = true;
            const DATA = { SEQ_NO: data.SEQ_NO, STATE: 4, };
            const result = await axiosPostHandler("siteCouponUpsertForAdmin.do", DATA);
            const isOk = result && result.message === "SUCCESS";
            if(isOk){setMessage({type:1, label:`쿠폰 삭제가 완료되었습니다.`});setList(before => before.filter((item) => item.SEQ_NO !== data.SEQ_NO));return;}
            if(result.message === "ALREADY_ISSUED"){setMessage({type:2, label:`이미 회원에게 발급된 쿠폰은 비활성화할 수 없습니다.`});return;}
            setMessage({type:2, label:`쿠폰 삭제에 실패 하였습니다.`});

        } finally { isLock.current = false; }
    }
    /* ==================== 쿠폰삭제 ==================== */
    const [ toggle,setToggle ] = useState(null);//공지내용토글
    const couponUpdateHandler = async(item) => {
        const DATA = {SEQ_NO:item.SEQ_NO}
        const result = await axiosPostHandler("siteCouponUpdateCheckForAdmin.do", DATA);
        const isOk = result && result.message === "SUCCESS";
        if(!isOk){return;}
        navigator("reg",{state:{...item, TYPE:result.data.result}})
    }
    return ( 
        <>
        <Element tag={`div`} className={styles.boardListContainer}>
            <Element tag={`ul`}>
                {list?.length > 0 && list.map((item, i) =>
                    <Element key={item.SEQ_NO} tag={`li`}>
                        <Element tag={`div`} className={toggle === item ? styles.selected : null}>
                            <Element tag={`div`} className={styles.title}>
                                <Element tag={`div`}><Element tag={`h2`} style={{width:'25rem'}}>{item.COUPON_NAME}</Element></Element>
                                <Element tag={`div`} className={styles.btnArea}>
                                    <Button anyprop={(e) => couponDeactivationAPI(item)} class={"subtitle"} icon="fa-light fa-trash-can" label={"삭제하기"} ></Button>
                                    <Button anyprop={(e) => couponUpdateHandler(item)} class={"subtitle"} icon="fa-light fa-pen-to-square" label={"수정하기"} ></Button>
                                    <a onClick={(e) => setToggle(toggle === item ? {} : item)}><FontAwesomeIcon icon={["fa-light", toggle === item ? "fa-chevron-up": "fa-chevron-down"].join(" ")} /></a>
                                </Element>
                            </Element>
                            <Element tag={`div`} className={styles.info}>
                                <Element tag={`div`}><Element tag={`span`}>{item.START_DT.split(".")[0] + " ~ " + item.END_DT.split(".")[0]}</Element></Element><Element tag={`hr`} />
                                <Element tag={`div`}><Element tag={`span`}>{item.COUPON_CD}</Element></Element>
                            </Element>
                        </Element>
                        {toggle === item ? 
                            <Element tag={`article`}>
                                <Element tag={`pre`}>할인 타입: {item.DISCOUNT_TYP === "R" ? "비율" : item.DISCOUNT_TYP === "A" ? "정액" : null}</Element>
                                <Element tag={`pre`}>쿠폰 발급 유형: {item.ISSUE_TYP === "A" ? "전회원" : item.ISSUE_TYP === "M" ? "개별발급" : item.ISSUE_TYP === "D" ? "다운로드": null}</Element>
                                <Element tag={`pre`}>중복사용여부: {item.IS_STACKABLE === "Y" ? "중복사용 가능" : item.IS_STACKABLE === "N" ? "중복사용 불가능" : null}</Element>
                                <Element tag={`pre`}>할인 값: {item.DISCOUNT_VALUE}</Element>
                                <Element tag={`pre`}>쿠폰만료기한까지: {item.DDAY+"일"}</Element>
                                <Element tag={`pre`}>비율 할인 시 최대 할인 금액: {item.MAX_DISCOUNT}</Element>
                                <Element tag={`pre`}>유저 1명당 최대 사용 가능 횟수: {item.MAX_USE_PER_USER}</Element>
                                <Element tag={`pre`}>쿠폰 사용 최소 주문 금액: {item.MIN_ORDER_PRICE}</Element>
                                <Element tag={`pre`}>발급 가능 수량: {item.TOTAL_QUANTITY === 0 ? "무제한" : item.TOTAL_QUANTITY}</Element>
                            </Element>
                        : null}
                    </Element>
                )}
            </Element>
        </Element>
        </>
    )
}